import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors } from "@styles/color.styles";

export const styles = {
  markerCircle: {
    position: "absolute",
    left: 0,
    marginLeft: -7,
    marginTop: -5,
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: colors.red.standard,
    zIndex: 3,
  } as CSSProperties,
  marker: {
    position: "absolute",
    width: "100%",
    borderTop: `1px solid ${colors.red.standard}`,
    borderBottom: `1px solid ${colors.red.standard}`,
    zIndex: 3,
  } as CSSProperties,
};
